import React, { Fragment } from 'react';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

export default [
  {
    header: (
      <>
        {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
        <TranslatedCopy id='global.size' />{' '}
      </>
    ),
    id: 'code'
  },
  {
    header: (data, { totalShippedQty }) => (
      <>
        <TranslatedCopy id='global.shipped' />
        <span className='d-sm-h d-md-b'>
          {': '}
          {totalShippedQty}
        </span>
      </>
    ),
    id: 'totalShippedQty'
  }
];
